import React from "react";
import { TID } from "../lib/testIds";

export default function Marquee({ text, dark = false, slow = false }) {
    const items = new Array(6).fill(text);
    return (
        <div
            data-testid={TID.marquee}
            className="overflow-hidden py-8 md:py-10 border-y no-print"
            style={{
                background: dark ? "#0B0B0B" : "#F4EFE6",
                color: dark ? "#F4EFE6" : "#0B0B0B",
                borderColor: "rgba(201,169,106,0.4)",
            }}
        >
            <div className={`marquee-track ${slow ? "marquee-slow" : ""} font-didone italic text-4xl md:text-6xl lg:text-7xl`} style={{ letterSpacing: "0.02em" }}>
                {items.map((t, i) => (
                    <span key={i} className="inline-flex items-center">
                        <span>{t}</span>
                        <span className="mx-8 md:mx-16" style={{ color: "#C9A96A" }}>
                            <span className="inline-block" style={{ transform: "scaleX(-1)" }}>R</span>
                        </span>
                    </span>
                ))}
            </div>
        </div>
    );
}
